"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PlantsGrid_1 = __importDefault(require("../components/Plants/PlantsGrid"));
const AuthContext_1 = __importDefault(require("../Auth/AuthContext"));
const react_helmet_1 = require("react-helmet");
const utils_1 = require("../Auth/utils");
const Plants = (props) => {
    const { user } = (0, react_1.useContext)(AuthContext_1.default);
    return (react_1.default.createElement("div", { className: "flex w-full" },
        react_1.default.createElement(react_helmet_1.Helmet, null,
            react_1.default.createElement("title", null, "Pflanzen")),
        (0, utils_1.isAllowed)(user, ['read_plant', 'update_plant', 'delete_plant', 'create_plant']) ? (react_1.default.createElement(PlantsGrid_1.default, null)) : null));
};
exports.default = Plants;
